import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})

export class ResourcesService {
  private readonly resourcesBaseApiUrl: string;
  private readonly memicMinutesResourcesBaseApiUrl: string;
  private readonly documentTypesBaseApiUrl: string;
  private readonly featuredTopicsBaseApiUrl: string;
  private readonly secondaryFeaturedTopicsBaseApiUrl: string;

  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.resourcesBaseApiUrl = `${baseUrl}api/resources`;
    this.memicMinutesResourcesBaseApiUrl = `${baseUrl}api/resources/memic-minutes`;
    this.documentTypesBaseApiUrl = `${baseUrl}api/document-types`;
    this.featuredTopicsBaseApiUrl = `${baseUrl}api/featured-topics`;
    this.secondaryFeaturedTopicsBaseApiUrl = `${baseUrl}api/secondary-featured-topics`;
  }

  public getTopResources(industry: string, size: string, search: string | null = null) {
    let resourcesApiUrl = `${this.resourcesBaseApiUrl}/top/${industry}/${size}?search=${btoa(search!)}`;

    return this.dataService.get<any>(resourcesApiUrl);
  }

  public getTopErgonomicsResources(industry: string, size: string, search: string | null = null) {
    let resourcesApiUrl = `${this.resourcesBaseApiUrl}/top-ergonomics/${industry}/${size}?search=${btoa(search!)}`;

    return this.dataService.get<any>(resourcesApiUrl);
  }

  public getAllResources(industry: string) {
    let resourcesApiUrl = `${this.resourcesBaseApiUrl}/${industry}`;

    return this.dataService.get<any>(resourcesApiUrl);
  }

  public getResources(industry: string, pageSize: number, sortBy: string | null = null, continuationToken: string | null = null, search: string | null = null, documentTypes: Array<string> | null = null, featuredTopics: Array<string> | null = null, secondaryFeaturedTopics: Array<string> | null = null) {
    let resourcesApiUrl = `${this.resourcesBaseApiUrl}/${industry}/${pageSize}?search=${btoa(search!)}&documentTypes=${btoa(JSON.stringify(documentTypes))}&featuredTopics=${btoa(JSON.stringify(featuredTopics))}&secondaryFeaturedTopics=${btoa(JSON.stringify(secondaryFeaturedTopics))}&sortBy=${btoa(sortBy!)}`;

    return this.dataService.get<any>(resourcesApiUrl, continuationToken!);
  }

  public getAllMemicMinutesResources(industry: string) {
    let memicMinutesResourcesApiUrl = `${this.memicMinutesResourcesBaseApiUrl}/${industry}`;

    return this.dataService.get<any>(memicMinutesResourcesApiUrl);
  }

  public getMemicMinutesResources(industry: string, pageSize: number, sortBy: string | null = null, continuationToken: string | null = null, search: string | null = null, featuredTopics: Array<string> | null = null, secondaryFeaturedTopics: Array<string> | null = null) {
    let memicMinutesResourcesApiUrl = `${this.memicMinutesResourcesBaseApiUrl}/${industry}/${pageSize}?search=${btoa(search!)}&featuredTopics=${btoa(JSON.stringify(featuredTopics))}&secondaryFeaturedTopics=${btoa(JSON.stringify(secondaryFeaturedTopics))}&sortBy=${btoa(sortBy!)}`;

    return this.dataService.get<any>(memicMinutesResourcesApiUrl, continuationToken!);
  }

  public getDocumentTypes(industry: string) {
    let documentTypesApiUrl = `${this.documentTypesBaseApiUrl}/${industry}`;

    return this.dataService.get<any>(documentTypesApiUrl);
  }

  public getFeaturedTopics(industry: string) {
    let featuredTopicsApiUrl = `${this.featuredTopicsBaseApiUrl}/${industry}`;

    return this.dataService.get<any>(featuredTopicsApiUrl);
  }

  public getSecondaryFeaturedTopics(industry: string) {
    let secondaryFeaturedTopicsApiUrl = `${this.secondaryFeaturedTopicsBaseApiUrl}/${industry}`;

    return this.dataService.get<any>(secondaryFeaturedTopicsApiUrl);
  }

  public downloadFile(file, industry, policy, emailAddress) {
    let fileId = file.id ?? file.lookupId;

    let fileApiUrl = `${this.resourcesBaseApiUrl}/files/${btoa(file.blobName)}/${fileId}/${btoa(file.title)}/${industry}/${btoa(file.primaryFeatureTopic)}/${btoa(file.documentType)}/${btoa(policy)}/${btoa(emailAddress)}`;

    return this.dataService.getFile(fileApiUrl);
  }

  public downloadWebinarFile(fileName, id) {
    let fileApiUrl = `${this.resourcesBaseApiUrl}/files/${btoa(fileName)}/${id}`;

    return this.dataService.getFile(fileApiUrl);
  }
}
